import waypointIcons from '../../icons/waypoints/icons';
import waypointPins from '../../icons/waypoints/pins';
import waypointIconPin from '../../icons/waypoints/iconPin';
import highlightLocationIcon from '../../icons/highlightLocationIcon';
import searchResultIcon from '../../icons/searchResultIcon';
import trailDirectionIcon from '../../icons/TrailDirectionIcon';
import {map, once, fromPairs} from 'lodash';
import {MapboxImage} from '../mapbox/Mapbox';

function fetchImg(src: string, key: string): Promise<[string, HTMLImageElement]> {
    return new Promise(resolve => {
        const img = document.createElement('img');
        img.src = src;
        img.onload = () => resolve([key, img]);
    });
}

const waypointIconPinImgPromise = fetchImg(waypointIconPin, 'waypoointIconPin');

async function fetchIconImg(src: string, key: string): Promise<[string, ImageData]> {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) { throw new Error(); }

    const [[, waypointIconPinImg], [, iconImg]] = await Promise.all([
        waypointIconPinImgPromise,
        fetchImg(src, key)
    ]);

    canvas.width = waypointIconPinImg.width;
    canvas.height = waypointIconPinImg.height;

    context.drawImage(waypointIconPinImg, 0, 0, canvas.width, canvas.height);
    context.drawImage(iconImg, 20, 16, iconImg.width, iconImg.height);

    return [key, context.getImageData(0, 0, canvas.width, canvas.height)];
}

export default once(async () => fromPairs(await Promise.all<[string, MapboxImage]>([
    fetchImg(highlightLocationIcon, 'highlightLocationIcon'),
    fetchImg(searchResultIcon, 'searchResultIcon'),
    fetchImg(trailDirectionIcon, 'trailDirectionIcon'),
    ...map(waypointPins, fetchImg),
    ...map(waypointIcons, fetchIconImg)
])));
